import React, { useEffect, useState } from 'react';
import SearchProduct from './SearchProduct';

export default function OrderItem({ item, itemKey, onRemove, errors, name="order_item", reset=false, id="product_id" }) {
    const [product, setProduct] = useState(null);
    const [price, setUnitPrice] = useState("");
    const [quantity, setQuantity] = useState("");
    const [isPriceTouched, setIsUnitPriceTouched] = useState(false);
    const [isQuantityTouched, setIsQuantityTouched] = useState(false);

    useEffect(() => {
        if(reset){
            setProduct(null);
            setUnitPrice("");
            setQuantity("");
            setIsUnitPriceTouched(false);
            setIsQuantityTouched(false);
        }
    }, [reset]);

    return (
        <fieldset className='order-item'>
            <div className='mb-1'>
                <label className='required' htmlFor={ `${ id }_${ item }` }>Produit</label>
                <input type='hidden' name={ `${ name }[${ item }]['product_id']` } value={ product ? product.id : '' } />
                <SearchProduct required={ true } id={ `${ id }` } updateProduct={ setProduct } item={ item } reset={ reset } defaultValue={ product } />
                { errors && errors[`${ name }.${ item }.product_id`] && <div className='form-error'>{ errors[`${ name }.${ item }.product_id`][0] }</div> }
            </div>
            <div className='row'>
                <div className='col-6 mb-3'>
                    <label className='required' htmlFor={ `${ name }_quantity_${ item }` }>Quantité</label>
                    <div className='position-relative'>
                        <input type='number' id={ `${ name }_quantity_${ item }` } step="1" min="1" name={ `${ name }[${ item }]['quantity']` } required placeholder='Quantité' className='form-control' autoComplete='off' value={ quantity } onChange={ (e) => setQuantity(e.target.value) } onBlur={ () => setIsQuantityTouched(true) } />
                        <span className='unit'>{ product && (product.unit === 'Item' ? 'pièce' + (quantity > 1 ? 's' : '') : (product.unit === 'Box' ? 'boîte' + (quantity > 1 ? 's' : '') : (product.unit === 'Carton' ? 'carton' + (quantity > 1 ? 's' : '') : ''))) }</span>
                    </div>
                    { isQuantityTouched && quantity.length === 0 && <div className='form-error'>Veuillez saisir la quantité.</div> }
                    { errors && errors[`${ name }.${ item }.quantity`] && <div className='form-error'>{ errors[`${ name }.${ item }.quantity`][0] }</div> }
                </div>
                <div className='col-6 mb-3'>
                    <label className='required' htmlFor={ `${ name }_unit_price_${ item }` }>Prix unitaire</label>
                    <input type='number' id={ `${ name }_unit_price_${ item }` } step="0.01" min="0" name={ `${ name }[${ item }]['unit_price']` } required placeholder='Prix unitaire' className='form-control' autoComplete='off' value={ price } onChange={ (e) => setUnitPrice(e.target.value) } onBlur={ () => setIsUnitPriceTouched(true) } />
                    { isPriceTouched && price.length === 0 && <div className='form-error'>Veuillez saisir le prix unitaire.</div> }
                    { errors && errors[`${ name }.${ item }.unit_price`] && <div className='form-error'>{ errors[`${ name }.${ item }.unit_price`][0] }</div> }
                </div>
            </div>
            <div className='text-end'>
                <button type='button' onClick={ () => onRemove(itemKey) } className='btn btn-sm btn-danger'><i className='fa fa-trash'></i> Supprimer</button>
            </div>
        </fieldset>
    )
}
